import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { cn } from "@/lib/utils"
import { Card } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { usePayment } from "../use-payment"
import { CreditCard, Upload } from "lucide-react"
import { Separator } from "@/components/ui/separator"
import LoanOfflinePaymentForm from "./loan"
import SelfOfflinePaymentForm from "./self"

const OfflinePayment = ({
	payment_id,
	finalAmout,
}: {
	payment_id: string
	finalAmout: number
}) => {
	const { formState, setValues } = usePayment()
	console.log("payment_id", payment_id)

	//  "pay-online" | "already-paid"
	const offlineOptions = [
		{
			id: "pay-online",
			name: "Pay Online",
			subtitle: "I'll Pay Online Payment",
			icon: CreditCard,
		},
		{
			id: "already-paid",
			name: "Already Paid",
			subtitle: "Upload Proof",
			icon: Upload,
		},
	]
	return (
		<div className="relative">
			<div className="">
				{formState.payment_type === "self" && (
					<RadioGroup
						className={cn(
							"df-radio-group",
							"grid grid-cols-1 gap-4 sm:grid-cols-2",
						)}
						// value={formState.payment_mode}
						defaultValue={formState.self_payment_mode}
						onValueChange={value => {
							setValues({
								self_payment_mode: value,
							})
						}}
					>
						{offlineOptions.length > 0 &&
							offlineOptions?.map(option => (
								<Card
									key={option.id}
									className={cn(
										"relative cursor-pointer transition-all duration-200 hover:shadow-md",
										"hover:border-primary/50 border-2 px-5 py-6",
										formState.self_payment_mode ===
											option.id &&
											"border-primary bg-primary/5 shadow-md",
									)}
									onClick={() => {
										setValues({
											self_payment_mode: option.id,
										})
									}}
								>
									<div
										className={cn(
											"flex items-start space-x-3",
											"items-center",
										)}
									>
										<RadioGroupItem
											value={option.id}
											id={option.id}
											className={cn(
												"mt-0.5",
												"peer sr-only",
											)}
										/>
										<div className="flex min-w-0 items-center justify-center gap-3">
											<div className="bg-primary rounded-full p-4">
												<option.icon className="stroke-white" />
											</div>
											<Label
												htmlFor={option.id}
												className={cn(
													"flex cursor-pointer flex-col justify-start text-xs font-normal leading-relaxed",
													formState.self_payment_mode ===
														option.id &&
														"font-medium",
												)}
											>
												{option.name}{" "}
												<span className="text-muted-foreground text-xs">
													{option.subtitle}
												</span>
											</Label>
										</div>
									</div>
								</Card>
							))}
					</RadioGroup>
				)}
				{(formState.payment_type === "self"
					? formState.self_payment_mode === "already-paid"
					: formState.loan_payment_mode === "loan-disbursed") && (
					<>
						<br />
						<Separator />
						<br />
					</>
				)}
				{formState.loan_payment_mode === "loan-disbursed" &&
					formState.payment_type == "loan" && (
						<LoanOfflinePaymentForm finalAmout={finalAmout} />
					)}
				{formState.self_payment_mode === "already-paid" &&
					formState.payment_type == "self" && (
						<SelfOfflinePaymentForm
							finalAmout={finalAmout}
							payment_id={payment_id}
						/>
					)}
			</div>
		</div>
	)
}

export default OfflinePayment
